import './platform';                       // setPlatform() before anything reads or syncs data
import React from 'react';
import { createRoot } from 'react-dom/client';
import { injectTokens } from './theme/cssVars';
import './styles/global.css';
import App from './App';
import { startServiceWorker } from './lib/sw';

injectTokens();
startServiceWorker();
createRoot(document.getElementById('root')).render(<App />);
